












import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { ModalStore, ModalInfo } from '@/stores/modal.store';

@Component({
  computed: {
    ...mapState<ModalStore>('ms', {
      modal: (state: ModalStore): ModalInfo | null => state.modal,
    }),
  },
})
export default class Modal extends Vue {
  modal!: any | null;

  get show(): boolean {
    return Boolean(this.modal);
  }

  close() {
    this.$store.commit('ms/closeModal');
  }
}
